import React from 'react';
import Seo from '../components/Seo';
import { motion } from 'framer-motion';
import CallForPricingGrid from '../components/CallForPricingGrid';
import { CLEARWATER_SPAS } from '../data/clearwaterSpas';

const SERIES = [
  { name: 'Resort Series', tag: 'Elite' },
  { name: 'Beachcraft Series', tag: 'Luxury' },
  { name: 'Northwest Series', tag: 'Performance' },
  { name: 'Fourwinds Series', tag: 'Classic' },
  { name: 'Starlight Series', tag: 'Value · Plug & Play' },
  { name: 'Swim Series', tag: 'Swim Spas' },
  { name: 'Cold Series', tag: 'Cold Tubs' },
];

const ClearwaterSpasPage = () => (
  <>
    <Seo page="/clearwater-spas" />
    <div className="pt-36 pb-20" style={{ background: 'linear-gradient(180deg, #ffffff 0%, #E0FFFF 20%, #AFEEEE 50%, #98FB98 80%, #F0FFF0 100%)' }} data-testid="clearwater-spas-page">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="mb-6">
          <span className="text-sm font-semibold text-[#F88200] uppercase tracking-wider">Affordable Luxury · Made in USA</span>
          <h1 className="font-['Barlow_Condensed'] text-4xl sm:text-5xl lg:text-6xl font-bold uppercase text-[#0E3D95] mb-4">Clearwater Spas</h1>
          <p className="text-lg text-slate-600 max-w-3xl">
            Handcrafted hot tubs with advanced jet systems, ergonomic seating and elegant cabinetry — plus XL swim spas and the Rejuvenate cold tub. Click any model for photos, full specifications and standard features. Call or email for pricing.
          </p>
          <div className="flex flex-wrap gap-2 mt-6" data-testid="clearwater-series-nav">
            {SERIES.map((s) => (
              <a key={s.name} href={`#${s.name.replace(/\s+/g, '-').toLowerCase()}`} className="px-4 py-2 rounded-full bg-white border border-[#0E3D95]/20 text-[#0E3D95] text-sm font-semibold hover:bg-[#0E3D95] hover:text-white transition-colors" data-testid={`clearwater-series-link-${s.name.split(' ')[0].toLowerCase()}`}>
                {s.name}
              </a>
            ))}
          </div>
        </motion.div>

        {SERIES.map((s) => (
          <div key={s.name} id={s.name.replace(/\s+/g, '-').toLowerCase()} className="scroll-mt-32">
            <CallForPricingGrid
              eyebrow={`Clearwater Spas · ${s.tag}`}
              title={s.name}
              items={CLEARWATER_SPAS.filter((p) => p.series === s.name)}
              testId={`clearwater-${s.name.split(' ')[0].toLowerCase()}-grid`}
            />
          </div>
        ))}
      </div>
    </div>
  </>
);

export default ClearwaterSpasPage;
